import { useCurrency } from '../lib/currency';
import { theme } from '../styles/theme';

/**
 * Renderiza un precio dual: principal en moneda preferida + secundario chiquito.
 * Si solo se pasa msrpUsd, se calcula MXN desde el FX vigente.
 * Si solo se pasa msrpMxn (legacy), se invierte.
 *
 * Convención NULED: source-of-truth = USD. MXN se deriva del TC del momento.
 */
export function Price({
  usd,
  mxn,
  size = 'md',
  showSecondary = true,
}: {
  usd?: number | null;
  mxn?: number | null;
  size?: 'sm' | 'md' | 'lg';
  showSecondary?: boolean;
}) {
  const { display } = useCurrency();
  const { primary, secondary } = display(usd ?? null, mxn ?? null);

  const fontSize = size === 'lg' ? 24 : size === 'sm' ? 13 : 17;
  const subSize = size === 'lg' ? 13 : size === 'sm' ? 10 : 11;

  return (
    <div style={{ lineHeight: 1.15 }}>
      <div style={{
        fontFamily: theme.font.head,
        fontWeight: 700,
        fontSize,
        color: theme.brand,
      }}>
        {primary}
      </div>
      {showSecondary && secondary && (
        <div style={{
          fontSize: subSize,
          color: theme.textMuted,
          marginTop: 2,
          fontWeight: 500,
        }}>
          ≈ {secondary}
        </div>
      )}
    </div>
  );
}

/**
 * Toggle USD/MXN compacto. Persiste en localStorage.
 */
export function CurrencyToggle({ size = 'md' }: { size?: 'sm' | 'md' }) {
  const { preferred, setPreferred, usdMxn, fetchedAt } = useCurrency();
  const padding = size === 'sm' ? '4px 8px' : '6px 10px';
  const fontSize = size === 'sm' ? 10 : 11;
  const tcLabel = usdMxn ? `1 USD = $${usdMxn.toFixed(2)} MXN` : 'TC cargando…';
  const ts = fetchedAt ? new Date(fetchedAt) : null;
  const tsLabel = ts ? ts.toLocaleString('es-MX', { hour: '2-digit', minute: '2-digit' }) : '';

  return (
    <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2 }}>
      <div style={{ display: 'inline-flex', border: `1px solid ${theme.border}`, background: theme.bg }}>
        <button
          onClick={() => setPreferred('MXN')}
          style={{
            background: preferred === 'MXN' ? theme.brand : 'transparent',
            color: preferred === 'MXN' ? theme.textOnBrand : theme.brand,
            border: 'none',
            padding,
            fontSize,
            fontWeight: 700,
            letterSpacing: 0.4,
            cursor: 'pointer',
            fontFamily: theme.font.sans,
          }}
        >
          MXN
        </button>
        <button
          onClick={() => setPreferred('USD')}
          style={{
            background: preferred === 'USD' ? theme.brand : 'transparent',
            color: preferred === 'USD' ? theme.textOnBrand : theme.brand,
            border: 'none',
            padding,
            fontSize,
            fontWeight: 700,
            letterSpacing: 0.4,
            cursor: 'pointer',
            fontFamily: theme.font.sans,
          }}
        >
          USD
        </button>
      </div>
      <div
        title={`Actualizado ${tsLabel}`}
        style={{ fontSize: 9, color: theme.textMuted, letterSpacing: 0.3 }}
      >
        {tcLabel}
      </div>
    </div>
  );
}
